import Nfe from "@/domain/notas/nfe/Nfe.js";
import Table from "./Table";
export default class TableNfe extends Table {
    constructor(component) {
        super(component);
    }

    getHeaders() {
        var headers;
        let nameTipo = this.component != undefined ? (this.component.tipo == 'recebida' ? "Fornecedor" : 'Cliente') : ''
        let valueTipo = this.component != undefined ? (this.component.tipo == 'recebida' ? "emitNome" : 'destNome') : ''
        headers = [
            { text: "Ações", value: "acoes", show: true, pesq: false, enable: false },
            { text: "Data de Emissão", value: "emissao", show: true, pesq: false, enable: true },
            { text: "Número", value: "numero", show: true, pesq: true, enable: true },
            { text: "Série", value: "serie", show: true, pesq: false, enable: true },
            { text: nameTipo, value: valueTipo, show: true, pesq: false, enable: true },
            { text: "Valor da NF-e", value: "valor", show: true, pesq: false, enable: true },
            { text: "Valor do PIS", value: "valorPis", show: true, pesq: false, enable: true },
            { text: "Valor do IPI", value: "valorIpi", show: true, pesq: false, enable: true },
            { text: "Valor do ICMS", value: "valorIcms", show: true, pesq: false, enable: true },
            { text: "Valor do COFINS", value: "valorCofins", show: true, pesq: false, enable: true },
            { text: "Valor do FCP", value: "valorFcp", show: true, pesq: false, enable: true },
            { text: "Valor do BCST", value: "valorBcst", show: true, pesq: false, enable: true },
            { text: "CNPJ do Emitente", value: "emitCnpj", show: true, pesq: true, enable: true },
            { text: "Chave de Acesso", value: "chave", show: true, pesq: true, enable: true },
            { text: "IE", value: "emitIe", show: true, pesq: true, enable: true },
            { text: "CNPJ/CPF do Destinatário", value: "destCnpj", show: true, pesq: false, enable: true },
            { text: "Origem", value: "origem", show: true, pesq: false, enable: true },
            { text: "Protocolada", value: "protocolada", show: true, pesq: false, enable: true },
            { text: "Status", value: "status", show: true, pesq: false, enable: true },
            { text: "Tipo", value: "tipo", show: true, pesq: false, enable: true },
            { text: "Transportados", value: "transportados", show: true, pesq: false, enable: true },
            { text: "UF de Origem", value: "ufOrigem", show: true, pesq: false, enable: true },
            { text: "Manifestacao", value: "manifestacao", show: true, pesq: false, enable: true },
            { text: "Data de Importação", value: "dtImportacao", show: true, pesq: false, enable: true },
            { text: "Vínculo", value: "vinculo", show: true, pesq: false, enable: true },
            { text: "Status ERP", value: "statusErp", show: true, pesq: false,enable:true},
            { text: "Status XML FTP", value: "ftpPython", show: true, pesq: false,enable:true},
            { text: "Status PDF FTP", value: "ftpPythonPdf", show: true, pesq: false,enable:true},
            { text: "log integração XML FTP", value: "logErroFtpXml", show: false, pesq: false,enable:true},
            { text: "log integração PDF FTP", value: "logErroFtpPdf", show: false, pesq: false,enable:true},
            { text: "log integração ERP", value: "log_statusErp", show: false, pesq: false,enable:true},
            { text: "Id Fluig", value: "id_fluig", show: true, pesq: true,enable:true},
            { text: "log integração ERP Dois", value: "log_statusErpDois", show: false, pesq: false,enable:true},
            { text: "StatusErp Dois", value: "statusErpDois", show: true, pesq: false,enable:true},
            { text: "Vencimento", value: "duplicata", show: true, pesq: false, enable: true },
            { text: "Produtos", value: "produtos", show: true, pesq: false, enable: true },
            { text: "xmlCce", value: "xmlCce", show: false, pesq: false, enable: false },
            { text: "cte", value: "cte", show: false, pesq: false, enable: false },
            { text: "Danfe", value: "danfe", show: false, pesq: false, enable: false },
            { text: "_id", value: "_id", show: false, pesq: false, enable: false },
            { text: "id_empresa", value: "empresa", show: false, pesq: false, enable: false },
            { text: "docZip", value: "docZip", show: false, pesq: false, enable: false },
            { text: "Natureza Operação", value: "natOp", show: true, pesq: true, enable: true },
            { text: "Informações adicionais", value: "inf_ad", show: true, pesq: false, enable: true },
            { text: "Sistema", value: "verProc", show: true, pesq: false, enable: true},
            { text: "Data ERP", value: "data_erp", show: true, pesq: false, enable: true},
            { text: "Departamento", value: "departamento", show: true, pesq: false, enable: true},
            { text: "CNPJ da Transportadora", value: "trans_cnpj", show: true, pesq: true, enable: true },
            { text: "Nome da Transportadora", value: "trans_nome", show: true, pesq: true, enable: true },
            { text: "Peso Líquido (em kg)", value: "trans_pesoL", show: true, pesq: true, enable: true },
            { text: "Peso Bruto (em kg)", value: "trans_pesoB", show: true, pesq: true, enable: true },
            { text: "Espécie dos volumes transportados", value: "trans_esp", show: true, pesq: true, enable: true },
            { text: "Quantidade de volumes transportados", value: "trans_qVol", show: true, pesq: true, enable: true },
            { text: "Modalidade do frete", value: "trans_modFrete", show: true, pesq: true, enable: true },
            { text: "Pós Fechametno", value: "posFechamento", show: true, pesq: false, enable: true}
        ]
        return headers
    }

    setNota(arrayNotas, notas) {
        let newArray = arrayNotas;
        this.loading = false;
        for (var i = 0; i < notas.length; i++) {
            newArray.push(
                new Nfe(
                    notas[i]._id,
                    notas[i].empresa,
                    notas[i].chave,
                    notas[i].emitNome,
                    notas[i].destNome,
                    notas[i].emitCnpj,
                    notas[i].emitCpf,
                    notas[i].emitIe,
                    notas[i].destCnpj,
                    notas[i].destCpf,
                    notas[i].origem,
                    notas[i].protocolada,
                    notas[i].serie,
                    notas[i].status,
                    notas[i].tipo,
                    notas[i].transportados,
                    notas[i].ufOrigem,
                    notas[i].manifestacao,
                    notas[i].numero,
                    notas[i].valorCofins,
                    notas[i].valorIcms,
                    notas[i].valorPis,
                    notas[i].valorIpi,
                    notas[i].valorFcp,
                    notas[i].valorBcst,
                    notas[i].valor,
                    notas[i].dtImportacao,
                    notas[i].emissao,
                    notas[i].danfe,
                    notas[i].xmlCce,
                    notas[i].cte,
                    notas[i].customValues,
                    notas[i].duplicata,
                    notas[i].produtos,
                    notas[i]['statusErp'],
                    notas[i].ftpPython,
                    notas[i].ftpPythonPdf,
                    notas[i].logErroFtpXml,
                    notas[i].logErroFtpPdf,
                    notas[i].log_statusErp,
                    notas[i].id_fluig,
                    notas[i].log_statusErpDois,
                    notas[i].statusErpDois,
                    notas[i].docZip,
                    notas[i].natOp,
                    notas[i].inf_ad,
                    notas[i].verProc,
                    notas[i].data_erp,
                    notas[i].departamento,
                    notas[i].trans_cnpj,
                    notas[i].trans_nome,
                    notas[i].trans_pesoL,
                    notas[i].trans_pesoB,
                    notas[i].trans_esp,
                    notas[i].trans_qVol,
                    notas[i].trans_modFrete,
                    notas[i].posFechamento
                )
            );
            this.pagination.sortBy = 'emissao';
            this.pagination.descending = true;
            // arrayNotas.sort(function (a, b) {
            //     return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
            // });

        }
        if(arrayNotas.length > 0) {
            arrayNotas = [ ...arrayNotas, ...newArray ];
            return arrayNotas;
        }else {
            return newArray;
        }
    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableNfe.js